// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__S8CdT","spin":"style_spin__3wR6d","imgWrapper":"style_imgWrapper__Ijbeb","invisible":"style_invisible__3dsnY"};